const BASE_URL = 'https://s3-us-west-2.amazonaws.com/disengage-icons';

export const getIconUrl = (index, icon, type, isHighlighted) => {
  return isHighlighted
    ? `${BASE_URL}/${icon}/${icon}_${type}/${index}.png`
    : `${BASE_URL}/${icon}/${icon}_${type}/${index}_bw.png`;
};
